//  icons
import {
  FiFacebook,
  FiInstagram,
  FiGithub,
  FiLinkedin,
  FiLayout,
  FiCode,
  FiDatabase,
  FiImage,
  FiMail,
  FiMapPin,
  FiMonitor,
} from 'react-icons/fi';

// companies icons
import FreelancerBrandIcon from './assets/img/brands/freelancer.png';
import UpworkBrandIcon from './assets/img/brands/upwork.png';
import FiverBrandIcon from './assets/img/brands/fiverr.png';
import BehanceBrandIcon from './assets/img/brands/behance.png';
import DribbbleBrandIcon from './assets/img/brands/dribbble.png';

// skills images
import SkillImg1 from './assets/img/skills/html5.png';
import SkillImg2 from './assets/img/skills/css3.png';
import SkillImg3 from './assets/img/skills/js.png';
import SkillImg4 from './assets/img/skills/reactjs.png';
import SkillImg5 from './assets/img/skills/mongodb.png';
import SkillImg6 from './assets/img/skills/nodejs.png';
import SkillImg7 from './assets/img/skills/express.png';
import SkillImg8 from './assets/img/skills/wordpress.png';
import SkillImg9 from './assets/img/skills/git.png';
import SkillImg10 from './assets/img/skills/figma.png';

// skills images
import css from './assets/icons/css.svg'
import express from './assets/icons/express.svg'
import git from './assets/icons/git.svg'
import github from './assets/icons/github.svg'
import html from './assets/icons/html.svg'
import javascript from './assets/icons/javascript.svg'
import mongodb from './assets/icons/mongodb.svg'
import motion from './assets/icons/motion.svg'
import mui from './assets/icons/mui.svg'
import nextjs from './assets/icons/nextjs.svg'
import nodejs from './assets/icons/nodejs.svg'
import react from './assets/icons/react.svg'
import redux from './assets/icons/redux.svg'
import sass from './assets/icons/sass.svg'
import tailwindcss from './assets/icons/tailwindcss.svg'
import typescript from './assets/icons/typescript.svg'
import bootstrap from './assets/icons/bootstrap.svg'
import mongoose from './assets/icons/mongoose.svg'
import figma from './assets/icons/figma.svg'

// testimonial images
import TestiImage1 from './assets/img/testimonials/timon.jpg';
import TestiImage2 from './assets/img/testimonials/delowar.jpg';
import TestiImage3 from './assets/img/testimonials/mainul.jpg';
import TestiImage4 from './assets/img/testimonials/masud.jpg';

// navigation
export const navigation = [
  {
    name: 'home',
    href: 'home',
  },
  {
    name: 'about',
    href: 'about',
  },
  {
    name: 'projects',
    href: 'projects',
  },
  {
    name: 'services',
    href: 'services',
  },
  {
    name: 'testimonials',
    href: 'testimonials',
  },
  {
    name: 'contact',
    href: 'contact',
  },
];

// social
export const social = [
  {
    icon: <FiFacebook />,
    href: 'https://www.facebook.com/moazzemhossainnahid/',
  },
  {
    icon: <FiInstagram />,
    href: 'https://www.instagram.com/moazzemhossainnahid/',
  },
  {
    icon: <FiGithub />,
    href: 'https://github.com/moazzemhossainnahid',
  },
  {
    icon: <FiLinkedin />,
    href: 'https://www.linkedin.com/in/moazzemhossainnahid/',
  },
];

// companies
export const brands = [
  {
    img: FreelancerBrandIcon,
    href: '',
  },
  {
    img: UpworkBrandIcon,
    href: '',
  },
  {
    img: FiverBrandIcon,
    href: '',
  },
  {
    img: BehanceBrandIcon,
    href: '',
  },
  {
    img: DribbbleBrandIcon,
    href: '',
  },
];

// projects
export const projectsData = [
  {
    id: '1',
    image: 'https://res.cloudinary.com/dsigyjfjq/image/upload/fl_preserve_transparency/v1741700874/Untitled_design_njjmyi.jpg',
    name: 'Druckkand',
    category: 'Team Projects',
    description: 'Druckland is a modern printing business website built with Next.js for seamless performance and fast rendering. This platform allows users to sign in, customize, and purchase printed products effortlessly.',
    githubClient: '',
    githubServer: '',
    LiveLink: 'https://frontend.druckland.de/',
  },
  {
    id: '2',
    image: 'https://res.cloudinary.com/dsigyjfjq/image/upload/fl_preserve_transparency/v1741707867/Untitled_design_1_isdsur.jpg',
    name: 'Clarhet Io',
    category: 'MERN Stack Projects',
    description: 'Clarhet.io is a powerful dashboard management software designed to help organizations streamline their operations, track key metrics, and make data-driven decisions with ease. It provides an intuitive interface for managing users, projects, and analytics, offering real-time insights to enhance productivity.',
    githubClient: '',
    githubServer: '',
    LiveLink: 'https://clarhet.io/',
  },
  {
    id: '3',
    image: 'https://i.ibb.co/WWZhNsD/online-bank-bd.png',
    name: 'Online Bank BD',
    category: 'Team Projects',
    description: 'This website is a Banking website. users can signin and buy product from here.This website has some feature and functionality.This website create in React.',
    githubClient: 'https://github.com/moazzemhossainnahid/online-bank-of-bd-client',
    githubServer: 'https://github.com/moazzemhossainnahid/online-bank-of-bd-server',
    LiveLink: 'https://online-money-bd.netlify.app/',
  },
    {
    id: '4',
    image: 'https://i.ibb.co/xLsMTX3/virtual-experts.png',
    name: 'Virtual Experts',
    category: 'MERN Stack Projects',
    description: 'This website is an Amazon FBA Consultancy company website. users can order services from here.This website has some extra features and functionality.This website create in Next.js.',
    githubClient: 'https://github.com/moazzemhossainnahid/virtual-experts-client',
    githubServer: 'https://github.com/moazzemhossainnahid/virtual-experts-server',
    LiveLink: 'https://amzvirtualexperts.com/',
  },
  {
    id: '5',
    image: 'https://res.cloudinary.com/dsigyjfjq/image/upload/fl_preserve_transparency/v1741708233/Untitled_design_2_e0ehzh.jpg',
    name: 'SeaCox',
    category: 'Simple React Projects',
    description: 'Seacox is a comprehensive restaurant management website built to streamline operations, enhance customer experience, and optimize efficiency. It offers features like order management, table reservations, inventory tracking, and staff coordination. Built with a user-friendly interface, Seacox empowers restaurant owners to manage their business effortlessly.',
    githubClient: '',
    githubServer: '',
    LiveLink: 'https://seacox.vercel.app/',
  },
  {
    id: '6',
    image: 'https://i.ibb.co/WyycjcR/dm-institute-bd.png',
    name: 'Digital Marketing Institute',
    category: 'Team Projects',
    description: 'This website is a Learning Management System website. users can signin and buy course from here.This website has huge feature and functionality.This website create in Next.js.',
    githubClient: 'https://github.com/moazzemhossainnahid/lms-client',
    githubServer: 'https://github.com/moazzemhossainnahid/lms-server',
    LiveLink: 'https://www.dminstitutebd.com/',
  },
  {
    id: '7',
    image: 'https://i.ibb.co/tb8wVmx/emotion-products.png',
    name: 'Emotion Products',
    category: 'MERN Stack Projects',
    description: 'This website is an Emotion Brand Website. users can signin and buy products from here.This website has many feature and functionality.This website create in React, node, mongoDB.',
    githubClient: 'https://github.com/moazzemhossainnahid/emotion-products-client',
    githubServer: 'https://github.com/moazzemhossainnahid/emotion-products-server',
    LiveLink: 'https://emotionproducts.vercel.app/',
  },
  {
    id: '7',
    image: 'https://i.ibb.co/sC7MxxF/knowledge-dot.png',
    name: 'Knowledge Dot',
    category: 'MERN Stack Projects',
    description: 'This is a Learning Management Website. users can signin and buy courses from here.This website has some all educational features and functionality.This website create in React.',
    githubClient: 'https://github.com/moazzemhossainnahid/knowledge-dot-client',
    githubServer: 'https://github.com/moazzemhossainnahid/knowledge-dot-server-II',
    LiveLink: 'https://knowledgedot7.web.app/',
  },
  // {
  //   id: '7',
  //   image: 'https://i.ibb.co/7zsmmyh/smart-ticketing.png',
  //   name: 'Smart Ticketing',
  //   category: 'Simple React Projects',
  //   description: 'Its An online ticket-selling website allows users to conveniently purchase tickets for various events, services, or destinations through the internet. Users can browse available options, select desired tickets, make payments securely, and receive digital tickets or confirmations via email or mobile devices.',
  //   githubClient: 'https://github.com/moazzemhossainnahid/smart-ticketing',
  //   LiveLink: 'https://smart-ticketing-bd.vercel.app/',
  // },

];

// projects
export const projectsNav = [
  {
    name: 'all',
  },
  {
    name: 'MERN Stack Projects',
  },
  {
    name: 'Simple React Projects',
  },
  {
    name: 'Team Projects',
  },
];

// skill
export const skills = [
  {
    image: SkillImg1,
  },
  {
    image: SkillImg2,
  },
  {
    image: SkillImg3,
  },
  {
    image: SkillImg4,
  },
  {
    image: SkillImg5,
  },
  {
    image: SkillImg6,
  },
  {
    image: SkillImg7,
  },
  {
    image: SkillImg8,
  },
  {
    image: SkillImg9,
  },
  {
    image: SkillImg10,
  },
];

// skillsData
export const skillsData = [
  {
    imageUrl: html,
    name: "HTML",
    type: "Frontend",
  },
  {
    imageUrl: css,
    name: "CSS",
    type: "Frontend",
  },
  {
    imageUrl: bootstrap,
    name: "Bootstrap",
    type: "Frontend",
  },
  {
    imageUrl: javascript,
    name: "JavaScript",
    type: "Frontend",
  },
  {
    imageUrl: tailwindcss,
    name: "Tailwind CSS",
    type: "Frontend",
  },
  {
    imageUrl: react,
    name: "React",
    type: "Frontend",
  },
  {
    imageUrl: redux,
    name: "Redux",
    type: "State Management",
  },
  {
    imageUrl: typescript,
    name: "TypeScript",
    type: "Frontend",
  },
  {
    imageUrl: git,
    name: "Git",
    type: "Version Control",
  },
  {
    imageUrl: github,
    name: "GitHub",
    type: "Version Control",
  },
  {
    imageUrl: figma,
    name: "Figma",
    type: "Frontend",
  },
  {
    imageUrl: express,
    name: "Express",
    type: "Backend",
  },
  {
    imageUrl: nodejs,
    name: "Node.js",
    type: "Backend",
  },
  {
    imageUrl: nextjs,
    name: "Next.js",
    type: "Frontend",
  },
  {
    imageUrl: mongodb,
    name: "MongoDB",
    type: "Database",
  },
  {
    imageUrl: mongoose,
    name: "Mongoose",
    type: "Database",
  },
  {
    imageUrl: motion,
    name: "Motion",
    type: "Animation",
  },
  {
    imageUrl: mui,
    name: "Material-UI",
    type: "Frontend",
  },
  {
    imageUrl: sass,
    name: "Sass",
    type: "Frontend",
  },

];

// services
export const services = [
  {
    icon: <FiCode />,
    name: 'Frontend Development',
    description:
      'Develop dynamic, interactive user interfaces using React, Next.js, and modern JavaScript. Ensure a seamless user experience with fast, responsive web applications.',
  },
  {
    icon: <FiDatabase />,
    name: 'Backend Development',
    description:
      'Build robust, scalable backend systems with Node.js, Express, and MongoDB. Handle API creation, database management, and server-side logic for dynamic websites and applications.',
  },
  {
    icon: <FiMonitor />,
    name: 'Full Stack Development',
    description:
      'Combine both frontend and backend skills to build end-to-end web solutions. From designing UI/UX to setting up servers, databases, and APIs, I deliver complete web applications using the MERN stack (MongoDB, Express, React, Node.js).',
  },
];


// testimonials
export const testimonials = [
  {
    authorImg: TestiImage1,
    authorText:
      'Working with MD Nahid has been seamless across both our projects—Emotion Production and Emotion Products. His expertise and dedication to delivering quality work have truly elevated our projects.',
    authorName: 'Timon Eijsink',
    authorPosition: 'Owner, Emotion Productions',
    authorLocation: 'Drachten, The Netherlands',
  },
  {
    authorImg: TestiImage2,
    authorText:
      'MD Nahid’s skill in web development and dedication were instrumental in creating a strong online presence for Digital Marketing Institute BD. He combines technical expertise with a genuine commitment to client satisfaction.',
    authorName: 'Delowar Sarker',
    authorPosition: 'Founder, Digital Marketing Institute BD',
    authorLocation: 'Dhaka, Bangladesh',
  },
  {
    authorImg: TestiImage3,
    authorText:
      'I’ve collaborated on the Virtual Experts LTD project with MD Nahid, and he consistently exceeded expectations. His work is thorough, and he approaches each task with great professionalism.',
    authorName: 'MD Mainul Islam',
    authorPosition: 'CEO, Virtual Experts LTD',
    authorLocation: 'New York, USA',
  },
  {
    authorImg: TestiImage4,
    authorText:
      'As a colleague on multiple projects, I’ve seen firsthand MD Nahid’s dedication and attention to detail. He brings both talent and teamwork to every project we take on.',
    authorName: 'Ali Ibne Masud',
    authorPosition: 'Web Developer & Colleague',
    authorLocation: 'Dhaka, Bangladesh',
  },
];


// contact
export const contact = [
  {
    icon: <FiMail />,
    title: 'Have a question?',
    subtitle: 'I am here to help you.',
    phone: '+880-1636-090316',
    description: `Email me at - moazzemhossainnahid@gmail.com`,
  },
  {
    icon: <FiMapPin />,
    title: 'Current Location',
    subtitle: 'Gazipur, Dhaka, Bangladesh',
    description: 'Serving clients worldwide',
  },
];
